<template>
  <img src="/images/notificationscenter.png" width="100%" />
</template>

<script>
// @ is an alias to /src

export default {
  name: "Home",
  components: {}
};
</script>
